// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppTopHeader-module__container__Tek2i {
  display: flex;
  width: 100%;
  padding: 10px 16px 10px 12px;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  background: #303048;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.AppTopHeader-module__pageName__ChVPI {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.AppTopHeader-module__rightContainer__l3zlR {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
}
.AppTopHeader-module__iconContainer__igg5Y {
  cursor: pointer;
}
.AppTopHeader-module__iconContainer__igg5Y :hover svg path {
  stroke: #e5e5eb;
}
.AppTopHeader-module__iconContainer__igg5Y :hover svg circle {
  stroke: #e5e5eb;
}
.AppTopHeader-module__divider__WRkNv {
  margin: 0 12px;
  border-right: 1px solid #797993;
  height: 32px;
}
.AppTopHeader-module__DepartmentSelectorButton__GnPpH {
  display: flex;
  max-width: 200px;
  height: 28px;
  padding: 0px 7px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-radius: 2px;
  background-color: transparent;
  border: 1px solid transparent;
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
  color: var(--cool-grey-3, #dbdbe3);
  text-align: center;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
  cursor: pointer;
}
.AppTopHeader-module__DepartmentSelectorButton__GnPpH:hover {
  background: var(--cool-grey-9, #595973);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}
.AppTopHeader-module__DepartmentSelectorButtonActive__cxZXH {
  background: var(--cool-grey-9, #595973);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}
.AppTopHeader-module__departmentToolTip__ew4vX {
  text-wrap: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/views/AppTopHeader.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AACF;AAEA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAAF;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AADF;AAIA;EACE,eAAA;AAFF;AACA;EAKQ,eAAA;AAHR;AAFA;EAQQ,eAAA;AAHR;AASA;EACE,cAAA;EACA,+BAAA;EACA,YAAA;AAPF;AAUA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,+CAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EARA,aAAa;EASb,eAAA;AAPF;AASE;EACE,uCAAA;EACA,+CAAA;AAPJ;AAWA;EACE,uCAAA;EACA,+CAAA;AATF;AAYA;EACE,iBAAA;AAVF","sourcesContent":[".container {\n  display: flex;\n  width: 100%;\n  padding: 10px 16px 10px 12px;\n  justify-content: space-between;\n  align-items: center;\n  height: 42px;\n  background: #303048;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n}\n\n.pageName {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.rightContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #eee;\n}\n\n.iconContainer {\n  cursor: pointer;\n  :hover {\n    svg {\n      path {\n        stroke: #e5e5eb;\n      }\n      circle {\n        stroke: #e5e5eb;\n      }\n    }\n  }\n}\n\n.divider {\n  margin: 0 12px;\n  border-right: 1px solid #797993;\n  height: 32px;\n}\n\n.DepartmentSelectorButton {\n  display: flex;\n  max-width: 200px;\n  height: 28px;\n  padding: 0px 7px;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 2px;\n  background-color: transparent;\n  border: 1px solid transparent;\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  color: var(--cool-grey-3, #dbdbe3);\n  text-align: center;\n  font-family: Nunito;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px; /* 157.143% */\n  cursor: pointer;\n\n  &:hover {\n    background: var(--cool-grey-9, #595973);\n    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n  }\n}\n\n.DepartmentSelectorButtonActive {\n  background: var(--cool-grey-9, #595973);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n\n.departmentToolTip {\n  text-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppTopHeader-module__container__Tek2i`,
	"pageName": `AppTopHeader-module__pageName__ChVPI`,
	"rightContainer": `AppTopHeader-module__rightContainer__l3zlR`,
	"iconContainer": `AppTopHeader-module__iconContainer__igg5Y`,
	"divider": `AppTopHeader-module__divider__WRkNv`,
	"DepartmentSelectorButton": `AppTopHeader-module__DepartmentSelectorButton__GnPpH`,
	"DepartmentSelectorButtonActive": `AppTopHeader-module__DepartmentSelectorButtonActive__cxZXH`,
	"departmentToolTip": `AppTopHeader-module__departmentToolTip__ew4vX`
};
export default ___CSS_LOADER_EXPORT___;
